/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.6.15",
    versionName: "0.4.0-nightly.2026.6.15",
    versionChannel: "nightly",
    buildDate: "2026-06-15T00:40:37.511Z",
    commitHash: "693fdd5e3680e7323c364befda7bf3ce8f9baa28",
};
